import React from "react";

import { SkeletonBlock } from "components/PageLoader/styled";

/**
 * Reusable SkeletonLoader
 * Props:
 * - count (number): number of skeleton items to render
 * - height (string): height of each skeleton block (e.g., '20px', '2rem')
 * - width (string): width of each skeleton block (default: '100%')
 * - borderRadius (string): border radius for skeleton (default: '8px')
 * - variant ('text' | 'circle' | 'rect'): shape of the skeleton
 * - style (object): optional inline styles
 * - className (string): custom className for styling
 */
const SkeletonLoader = ({
  count = 1,
  height = "20px",
  width = "100%",
  borderRadius = "8px",
  variant = "rect",
  style,
  className
}) => {
  return (
    <>
      {Array?.from({ length: count })?.map((_, i) => (
        <SkeletonBlock
          key={i}
          height={height}
          width={width}
          borderRadius={borderRadius}
          variant={variant}
          style={style}
          className={className}
        />
      ))}
    </>
  );
};

export default SkeletonLoader;
